module.exports = __webpack_public_path__ + "static/media/cardpay.f7b16570.svg";